export function normalizeTranslateValue(value?: number): number {
  return typeof value === "number" && Number.isFinite(value) ? value : 0;
}
